<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" *ngIf="deregistrationPackObject">
    <app-dict-registrations fxFlex="100" label="Rejestracja" [control]="registrationControl" [required]="true"
      [filterToDeregisterPack]="deregistrationPackObject"
    ></app-dict-registrations>
  </div>

  <div fxLayout="row" *ngIf="registrationObject">
    <app-dict-deregistration-packs fxFlex="100" label="Paczka wyrejestrowań" [control]="deregistrationPackControl" [required]="true"
      [filterByRegistration]="registrationObject"
    ></app-dict-deregistration-packs>
  </div>

  <div fxLayout="row">
    <button mat-stroked-button color="primary" [disabled]="!addRegistrationForm.valid" [class.spinner]="processingRequest"
            class="add-button" (click)="save()"><mat-icon>add</mat-icon> Dodaj</button>
  </div>
</div>
